const initialState = {
  isChatPanelOn: false
}


export const chatPanelReducer = (state = initialState, action) => {
  switch (action.type) {

    case "SET_CHATPANEL": {
      return { ...state, isChatPanelOn: action.data }
    }

    default:
      return state;

  }
};